import { render, staticRenderFns } from "./demandFeedback.vue?vue&type=template&id=524301b6&scoped=true&"
import script from "./demandFeedback.vue?vue&type=script&lang=js&"
export * from "./demandFeedback.vue?vue&type=script&lang=js&"
import style0 from "./demandFeedback.vue?vue&type=style&index=0&id=524301b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524301b6",
  null
  
)

export default component.exports